import script from "./Expand.vue?vue&type=script&lang=ts&setup=true"
export * from "./Expand.vue?vue&type=script&lang=ts&setup=true"

import "./Expand.vue?vue&type=style&index=0&id=2e67a3eb&lang=scss"

const __exports__ = script;

export default __exports__